import { useState } from 'react';
import { useAuth } from '../context/AuthProvider';
import { Outlet, useNavigation } from 'react-router-dom';
import Header from '../components/Header/index';
import Sidebar from '../components/Sidebar/index';
import Loader from '../components/Loader';

const DefaultLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { user } = useAuth();
    const navigation = useNavigation();

    return (
        <>
            {!user && (
                <div className='dark:bg-boxdark-2 dark:text-bodydark'>
                    <div className='flex h-screen overflow-hidden'>
                        <div className='relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden'>
                            <main>
                                <div className='w-full p-4 md:p-6 2xl:p-10'>
                                    {navigation.state === "loading" ? <Loader /> : <Outlet />}
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            )}

            {user && (
                <div className='dark:bg-boxdark-2 dark:text-bodydark'>
                    <div className='flex h-screen overflow-hidden'>
                        <Sidebar
                            sidebarOpen={sidebarOpen}
                            setSidebarOpen={setSidebarOpen}
                        />
                        <div className='relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden'>
                            <Header
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                            <main>
                                <div className='w-full p-4 md:p-6 2xl:p-10'>
                                    {navigation.state === "loading" ? <Loader /> : <Outlet />}
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DefaultLayout;
